import React, { useEffect, useState } from "react";
import { Breadcrumb, Table } from "antd";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../../components/loader/loader";
import "./platformFees.css";

const PlatformFees = () => {
  const [isloading, setIsLoading] = useState(false);
  const [summary, setSummary] = useState({});
  const [orders, setOrders] = useState([]);

  const fetchFees = () => {
    setIsLoading(true);
    callApi(
      "GET",
      `${routes.getAdminPlatformFees}?page=1&limit=50`,
      null,
      setIsLoading,
      (res) => {
        const data = res?.data || res;
        setSummary(data?.summary || {});
        setOrders(data?.feeByOrder || []);
      },
      (err) => {
        console.error("error fetching platform fees", err);
      },
    );
  };

  useEffect(() => {
    fetchFees();
  }, []);

  const columns = [
    { title: "Order ID", dataIndex: "orderId", key: "orderId" },
    { title: "Platform Fee", dataIndex: "platformFee", key: "platformFee" },
    {
      title: "Est Monnify Fee",
      dataIndex: "estimatedMonnifyFee",
      key: "estimatedMonnifyFee",
    },
    {
      title: "Est Profit",
      dataIndex: "estimatedProfit",
      key: "estimatedProfit",
    },
  ];

  return (
    <div className="page-content">
      <Loader loading={isloading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Platform Fees</Breadcrumb.Item>
      </Breadcrumb>
      <div className="page-title">Platform Fees</div>

      <div className="summary-cards">
        <div className="summary-card">
          <div className="label">Orders Count</div>
          <div className="value">{summary.ordersCount ?? "-"}</div>
        </div>
        <div className="summary-card">
          <div className="label">Total Order Value</div>
          <div className="value">{summary.totalOrderValue ?? "-"}</div>
        </div>
        <div className="summary-card">
          <div className="label">Total Platform Fee</div>
          <div className="value">{summary.totalPlatformFee ?? "-"}</div>
        </div>
        <div className="summary-card">
          <div className="label">Est Total Monnify Fee</div>
          <div className="value">{summary.estimatedTotalMonnifyFee ?? "-"}</div>
        </div>
        <div className="summary-card">
          <div className="label">Est Total Profit</div>
          <div className="value">{summary.estimatedTotalProfit ?? "-"}</div>
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={orders}
        rowKey={(r, i) => r.orderId || i}
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};

export default PlatformFees;
